import React from 'react'

const HomeText = () => {
	return (
		<>
			<h1>
				<span className="title-big">World's first</span> 3D NFT Market!
			</h1>
			<p className="home-text">
				Always wanted to dip your toes into NFTs, but didn't know where to buy
				them? We have great news for you! Purchasing NFTs has never been easier.
				Browse the ones we have in store by clicking on the top right button,
				and when you find one you like, simply click "Buy NFT". More will be
				added soon!
			</p>
		</>
	)
}

export default HomeText
